import Signal from 'libs/signals';

const notificationsSignal = Signal({
  notifications: {},
});

export default notificationsSignal;
